import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/Rx';
import { ProductService } from '../../../services/ProductService';
import { UserService } from '../../../services/UserService';
import { AdalService } from '../../../shared/adal.service';

@Component({
    selector: 'my-app-sidenav-menu',
    styles: [require('./sidenav-menu.component.css')],
    template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent implements OnInit {
    AppConfig: Object;
    currentUser: any;
    productList;    
    errorMessage: string;    
    ProductFilter: any = { ProductName: '' };    
    selectedTitle: '';
    IsAdmin:boolean;    
    selectedProductId;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private productService: ProductService,
        private userservice: UserService,
        private adalService:AdalService,
        ) {       
        // Check Authentication
        if (!this.adalService.getCachedToken()){            
            this.router.navigate(['login']);
        }
    }

    ngOnInit() {
        this.getUserRights(Number(localStorage.getItem('userid')));
        this.getProductReleaseList();        
    }

    getProductReleaseList(): void {        
        this.productService.getReleaseProductsList().subscribe(
            data => {    
                if(!data.IsError && data.DataObject!=null){
                    this.productList = data.DataObject;                    
                }
            },
            error => {
                this.errorMessage = error;
            });
    }    

    getStyle(selected) {        
        this.selectedTitle = selected;
    }

    removeStyle(){
        this.selectedTitle = '';
    }

    getUserRights(UserId){
        this.userservice.getUserById(UserId).subscribe(
            Data => {                                        
                this.IsAdmin = Data.IsAdmin;                
            },
             error => {
                this.errorMessage = error;
            });
    }
    checkSelected(product){
        if(this.route.firstChild != null){
            if(this.route.firstChild.firstChild != null){
                this.route.firstChild.firstChild.paramMap.subscribe((params)=>{
                    this.selectedProductId=params.get('id');
                })
                return product.ProductId==this.selectedProductId;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts